const newseLatterData2 = [
	{
		id: '1',
		icon: { parentBg: '#beaaf7', childBg: 'rgb(131 88 255) ', svg: 'icon-wallet' },

		title: [' Set', ' up', ' your', ' wallet'],
		text: "To begin, connect your wallet to the NFT marketplace by clicking connect wallet on the top right corner.",
	},
	{
		id: '2',
		icon: { parentBg: '#c4f2e3', childBg: 'rgb(16 185 129)', svg: 'icon-wallet' },

		title: ['Explore', ' NFTs', ' and', ' Collections'],
		text: 'Browse through the available NFTs listed for loan offers, and make offers on the NFTs you would like to loan.',
	},
	{
		id: '3',
		icon: { parentBg: '#cddffb', childBg: 'rgb(66 138 248)', svg: 'icon-gallery' },
		title: [' Borrower', ' Accepts', ' Your', ' Loan', ' Offer'],
		text: 'Once the borrower accepts your offer, the loan amount is transferred from your wallet to the borrower\'s wallet. The NFT is securely held by a smart escrow contract throughout the loan term.',
	},
	{
		id: '4',
		icon: { parentBg: '#ffd0d0', childBg: 'rgb(239 68 68)', svg: 'icon-list' },
		title: ['Earn', ' Interest'],
		text: 'Upon the borrower\'s timely repayment of the loan according to the agreed terms, you will automatically receive both your principal and the accrued interest in your wallet.',
	},
];

export { newseLatterData2 };
